<template>
  <div class="main">
    <c-panel title="Manutenções" titleIcon="fas fa-tools">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

